import React from "react";
import { withTranslation } from "react-i18next";

import { Help, NavigationButton } from "../../../../../components";

import "./index.scss";

const AuthenticationHelp = ({ renderLayout, onGoBack, onGoToCallForHelp, t }) => {
  const content = (
    <Help className="AuthenticationOptionsHelp">
      <div>
        <div>{t("kl_authentication_help3_part1").message || "To pick up your key, you must"}</div>
        <div>{t("kl_authentication_help3_part2").message || "use the PIN or scan QR Code"}</div>
      </div>
      <div>
        {t("kl_example").message || "Example"}
        <span className="AuthenticationOptionsHelpCode">123 456</span>
      </div>
    </Help>
  );

  const leftButton = <NavigationButton back onClick={onGoBack} />;

  const rightButton = (
    <NavigationButton icon="phone" onClick={onGoToCallForHelp}>
      {t("kl_call_for_help").message || "Call For Help"}
    </NavigationButton>
  );

  return renderLayout({ leftButton, rightButton, content });
};

export default withTranslation()(AuthenticationHelp);
